<div class="modal-header">
    <h4 class="modal-title">Donacion Exitosa</h4>
</div>
<div class="modal-body">
    <div style="display: grid; width: 100%">
        <!-- <img src="assets/images/LogotipoCoomevaMovil.png"> -->
        <!-- <p>Asociado(a), su donación en dinero por valor de ${{vlrDonacionPesosFinal}} será cargado a su estado de cuenta</p>
        <p>y su donación por {{vlrDonacionPinosFinal}} PINOS será redimida por el programa de Lealtad-Pinos.</p>
        <p>¡ Gracias por tu participación y solidaridad ¡</p> -->
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-icon btn-default" (click)="aceptarMensaje()">
        Aceptar
      </button>
</div>


// WEBPACK FOOTER //
// ./src/app/pages/modal-success-donacion/modal-success-donacion.component.html